module.exports = {"659003001":"锦绣街道","659003002":"前海街道","659003003":"永安坝街道","659003100":"草湖镇","659003101":"龙口镇","659003102":"前海镇","659003103":"永兴镇","659003104":"兴安镇","659003105":"嘉和镇","659003106":"河东镇","659003107":"夏河镇","659003108":"永安镇","659003109":"海安镇","659003110":"唐驿镇","659003111":"金胡杨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659003.json
// module id = 3295
// module chunks = 0